export default __webpack_public_path__ + "static/media/cargo.03d7434f.svg";